import React, { useState } from "react";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { useEarningsDataContext } from "@/store/EarningsProvider";
import Modal from "@/ui/Modal/Modal";
import { dataTrigger } from "@/analytics";
import cls from "./styles.module.scss";
import { CloseBtn } from "../CloseBtn/CloseBtn";

export const EarningsBlock = () => {
  const { earnings } = useEarningsDataContext();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const progressLineWidth =
    earnings.active.earned > 0
      ? (earnings.active.earned * 100) / earnings.active.total_possible
      : 0;

  const openModal = () => {
    setIsOpen(true);
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <FlexColumn gap={20} alignItems="center" className={cls.infoModal}>
          <CloseBtn
            onclose={() => setIsOpen(false)}
            trigger="ref.income_help.close"
          />

          <Typography variant="h3">
            Возможный доход
            <br />
            за активных рефералов
          </Typography>
          <Typography className={cls.label}>
            ЭТО МАКСИМАЛЬНАЯ СУММА, КОТОРУЮ ВЫ МОЖЕТЕ ПОЛУЧИТЬ ЗА ТЕКУЩИХ
            АКТИВНЫХ РЕФЕРАЛОВ — ЕСЛИ КАЖДЫЙ ИЗ НИХ ВЫПОЛНИТ ВСЕ ДОСТУПНЫЕ ЕМУ
            ЗАКАЗЫ

          </Typography>
        </FlexColumn>
      </Modal>

      <FlexColumn gap={6} className={cls.earningsBlock}>
        <FlexRow justifyContent="space-between">
          <Typography className={cls.label}>
            Доход за активных
            <br />
            рефералов
          </Typography>
          <Typography className={cls.label}>
            Возможный доход за
            <br />
            активных рефералов
          </Typography>
        </FlexRow>

        <FlexRow justifyContent="space-between">
          <Typography className={cls.earned}>
            {earnings.active.earned.toLocaleString("ru-RU")} ₽
          </Typography>
          <FlexRow>
            <Typography className={cls.totalPossible}>
              {earnings.active.total_possible.toLocaleString("ru-RU")} ₽
            </Typography>
            <button
              type="button"
              {...dataTrigger("ref.main.possible_income_help")}
              className={cls.questionBtn}
              onClick={openModal}
            >
              ?
            </button>
          </FlexRow>
        </FlexRow>
        <div className={cls.progressBar}>
          <div
            className={cls.progressLine}
            style={{ width: `${progressLineWidth}%` }}
          />
        </div>
      </FlexColumn>
    </>
  );
};
